import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-ach-green',
  templateUrl: './icon-ach-green.component.html',
  styles: []
})
export class IconAchGreenComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
